export const sxStyle = {
  gridExitoContainer: {
    width: { xs: '100% !important', sm: '98% !important' },
    minHeight: { xs: 'auto !important', sm: '300px !important' },
    backgroundColor: '#ffffff',
    borderRadius: { xs: '0px', sm: '8px' },
    margin: { xs: 0, sm: 'initial' },
  },
  divExitoContainer: {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    width: '100%',
    borderRadius: { xs: 0, sm: '8px' },
    padding: { xs: '20px', sm: '40px 40px 0 40px' },
    maxWidth: { xs: '100%', sm: 'initial' },
  },
  iconExitoContainer: {
    fontSize: { xs: '10vh', sm: '9vh' },
    color: '#03C868',
  },
  iconErrorContainer: {
    fontSize: { xs: '55px', sm: '70px' },
    color: 'red',
  },
  title: {
    fontWeight: 600,
    color: '#000',
    fontSize: { xs: '20px', sm: '35px' },
  },
  errorTitle: {
    fontWeight: 600,
    color: '#000',
    fontSize: { xs: '20px', sm: '35px' },
  },
  codes: {
    fontWeight: 500,
    color: '#000',
    fontSize: { xs: '12px', sm: '16px' },
  },

  codesValue: theme => ({
    fontWeight: 600,
    color: theme.palette.tertiary?.main || '#000',
    fontSize: { xs: '12px', sm: '16px' },
  }),
  email: {
    fontSize: { xs: '16px', sm: '18px' },
    color: '#000000',
    mt: { xs: 0, sm: '10px' },
  },

  boxNuevaReservaButton: {
    width: { xs: '70%', sm: '60%' },
  },
  nuevaReservaButton: {
    width: '280px',
    backgroundColor: '#fff',
    border: '1px solid #000',
    borderRadius: '8px',
    color: '#000',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
    m: '20px 0px',
    height: { xs: '40px', sm: 'auto' },
  },
  assistLogoContainer: {
    position: { xs: 'initial', sm: 'absolute' },
    top: { xs: 'initial', sm: '-20px' },
    right: { xs: 'initial', sm: '30px' },
  },
  assistLogo: {
    height: { xs: '80px', sm: 'auto' },
  },
};
